import React from "react";
import "./Package.css";
import { useNavigate } from "react-router-dom";

function Package({ packageType }) {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/package/" + packageType.name.toLowerCase());
  };
  return (
    <div className="packageContainer">
      <h2>{packageType.name}</h2>
      <h3>Starting at: {packageType.cost}</h3>
      {packageType.name === "Interior" || packageType.name === "Exterior" ? (
        <h3>
          Bundle with{" "}
          {packageType.name === "Exterior" ? "interior" : "exterior"} for $275
        </h3>
      ) : null}

      <img src={packageType.image} alt="" className="packageImage" />
      {packageType.name !== "Interior & Exterior" && (
        <button className="customButton" onClick={handleButtonClick}>
          More info
        </button>
      )}
    </div>
  );
}

export default Package;
